import { v4 as uuid } from 'uuid';

import {
  ADD_ASSIGNEE,
  ADD_ASSIGNEE_GROUP,
  ADD_STEP,
  CHANGE_ASSIGNEE,
  CHANGE_ASSIGNEE_GROUP,
  CHANGE_STEP_MODE,
  CLEAR_WORKFLOW_SAVED,
  REMOVE_ASSIGNEE,
  REMOVE_ASSIGNEE_GROUP,
  REMOVE_STEP,
  WORKFLOW_SAVE_STARTED,
  SET_WORKFLOW,
  SET_WORKFLOW_ERRORS
} from './actions';

const defaultAssigneeGroupState = {
  assignees: [],
  assigneesToDelete: [],
  mode: 'and_condition'
};

const defaultStepState = {
  assigneeGroups: [],
  assigneeGroupsToDelete: [],
  mode: 'and_condition'
};

function reindexItems(items) {
  for (const [index, item] of items.entries()) {
    item.index = index;
  }

  return items;
}

export function prepareWorkflow(workflow) {
  const steps = workflow.steps.map((step, stepIndex) => {
    const assigneeGroups = step.assigneeGroups.map((assigneeGroup, assigneeGroupIndex) => {
      const assignees = assigneeGroup.assignees.map((assignee, assigneeIndex) => {
        return {
          ...assignee,
          index: assigneeIndex,
          key: uuid()
        };
      });

      return {
        ...defaultAssigneeGroupState,
        ...assigneeGroup,
        index: assigneeGroupIndex,
        key: uuid(),
        assignees
      };
    });

    return {
      ...defaultStepState,
      ...step,
      assigneeGroups,
      index: stepIndex
    };
  });

  return {
    ...workflow,
    steps,
    stepsToDelete: []
  };
}

function setStep(state, step) {
  const steps = [...state.steps];
  steps[step.index] = step;

  return {
    ...state,
    steps
  };
}

function setAssigneeGroup(state, step, assigneeGroup) {
  const assigneeGroups = [...step.assigneeGroups];
  assigneeGroups[assigneeGroup.index] = assigneeGroup;

  return setStep(state, {
    ...step,
    assigneeGroups
  });
}

export default function(state = { steps: [], stepsToDelete: [] }, action) {
  switch (action.type) {
  case ADD_STEP: {
    const newStep = {
      ...defaultStepState,
      index: state.steps.length
    };

    return {
      ...state,
      steps: [...state.steps, newStep]
    };
  }

  case REMOVE_STEP: {
    const steps = [...state.steps];
    steps.splice(action.step.index, 1);

    return {
      ...state,
      steps: reindexItems(steps),
      stepsToDelete: [...state.stepsToDelete, action.step]
    };
  }

  case ADD_ASSIGNEE_GROUP: {
    const newGroup = {
      ...defaultAssigneeGroupState,
      index: action.step.assigneeGroups.length,
      key: uuid(),
      assignees: [{ index: 0, key: uuid() }]
    };

    return setStep(state, {
      ...action.step,
      assigneeGroups: [...action.step.assigneeGroups, newGroup]
    });
  }

  case CHANGE_ASSIGNEE_GROUP:
    return setAssigneeGroup(state, action.step, {
      ...action.assigneeGroup,
      ...action.changes
    });

  case REMOVE_ASSIGNEE_GROUP: {
    const assigneeGroups = [...action.step.assigneeGroups];
    assigneeGroups.splice(action.assigneeGroup.index, 1);

    return setStep(state, {
      ...action.step,
      assigneeGroups: reindexItems(assigneeGroups),
      assigneeGroupsToDelete: [...action.step.assigneeGroupsToDelete, action.assigneeGroup]
    });
  }

  case ADD_ASSIGNEE: {
    const assignees = [...action.assigneeGroup.assignees];
    assignees.push({
      index: assignees.length,
      key: uuid()
    });

    return setAssigneeGroup(state, action.step, {
      ...action.assigneeGroup,
      assignees
    });
  }

  case CHANGE_ASSIGNEE: {
    const assignee = {
      ...action.assignee,
      ...action.changes
    };

    const assignees = [...action.assigneeGroup.assignees];
    assignees[action.assignee.index] = assignee;

    return setAssigneeGroup(state, action.step, {
      ...action.assigneeGroup,
      assignees
    });
  }

  case REMOVE_ASSIGNEE: {
    const assignees = [...action.assigneeGroup.assignees];
    assignees.splice(action.assignee.index, 1);

    return setAssigneeGroup(state, action.step, {
      ...action.assigneeGroup,
      assignees: reindexItems(assignees),
      assigneesToDelete: [...action.assigneeGroup.assigneesToDelete, action.assignee]
    });
  }

  case CHANGE_STEP_MODE:
    return setStep(state, {
      ...action.step,
      mode: action.mode
    });

  case WORKFLOW_SAVE_STARTED:
    return {
      ...state,
      saving: true
    };

  case SET_WORKFLOW:
    return action.workflow;

  case CLEAR_WORKFLOW_SAVED:
    return {
      ...state,
      saved: false
    };

  case SET_WORKFLOW_ERRORS:
    return {
      ...state,
      errors: action.errors,
      saving: false
    };

  default:
    return state;
  }
}
